import { useMutation } from "@tanstack/react-query";
import type { Error as SdkError } from "@/api/cashier";
import { updateCardExpiryDateMutation } from "@/api/cashier/@tanstack/react-query.gen";

export const useUpdateCardExpiryDate = (
  savedPaymentAccountID: string,
  onSuccess?: () => void,
  onError?: (error: SdkError) => void
) => {
  const mutation = useMutation({
    ...updateCardExpiryDateMutation(),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: SdkError) => {
      onError?.(error);
    },
  });

  const updateExpiryDate = (expiry: string) => {
    mutation.mutate({
      path: { savedPaymentAccountID },
      body: { expiry_date: expiry },
    });
  };

  return {
    ...mutation,
    mutate: updateExpiryDate,
  };
};
